import { ISocketCommentProps, Status } from "../../../../../types/working-model";
import TimeSince from "./time-since";

interface IQuestionCommentsProps {
	comments: [number, ISocketCommentProps][];
}

const QuestionComments: React.FC<IQuestionCommentsProps> = ({ comments }) => {

	if (!comments?.length) return null;
	return (
		<div className="question-comment-cards-container">
			{comments.map(data => {
				const comment = data[1];
				const id = data[0];
				// we actually wnat to allow spam messages through because we want to display the message to the original sender
				// it will not be sent to anyone else because the socket won't trigger
				if (comment.status !== Status.Approved && !comment.spam) return null;
				return (
					<div className="question-comment-card" key={id}>
						<div>
							<div className="question-card-questionee">
								{comment?.moderator ? (
									<>Moderator </>
								) : (
									<>{comment.first_name} {comment.last_name} </>
								)}
								&bull; {<TimeSince createdAt={comment.created_at} />}
							</div>
						</div>
						<p>{comment.comment}</p>
					</div>
				);
			})}
		</div>
	);
};

export default QuestionComments;
